import {
  validateEmail,
  validateName,
  validatePhone,
} from '@/components/FormField';
import React from 'react';
import { Desktop, Mobile } from '@edreamsodigeo/frontend-core';
import { Box, Flex } from '@edreamsodigeo/prisma-design-system';
import {
  CriticalAlert,
  InformativeAlert,
} from '@/components/SummaryContactDetails/Alerts';

export const FIELDS = {
  NAME: { id: 'name', validation: validateName },
  SURNAME: { id: 'surname', validation: validateName },
  EMAIL: { id: 'email', validation: validateEmail },
  COUNTRY_CODE: {
    id: 'country_code',
    validation: (val = '') => (val || '').length > 0,
  },
  PHONE: { id: 'phone', validation: validatePhone },
};

export const FIELDS_WITH_CONFIRM = {
  ...FIELDS,
  EMAIL_CONFIRM: {
    id: 'email_confirm',
    validation: (value) => validateEmail(value),
  },
};

export const FormRow = ({ children }) => (
  <>
    <Mobile>{children}</Mobile>
    <Desktop>
      <Flex justifyContent="space-between">{children}</Flex>
    </Desktop>
  </>
);

export const StyledBoxDesktop = ({ children, ...props }) => (
  <>
    <Mobile>{children}</Mobile>
    <Desktop>
      <Box {...props}>{children}</Box>
    </Desktop>
  </>
);
export const StyledBoxMobile = ({ children, ...props }) => (
  <>
    <Desktop>{children}</Desktop>
    <Mobile>
      <Box {...props}>{children}</Box>
    </Mobile>
  </>
);

export const AlertBox = ({ showCriticalAlert, isActiveLoading }) => {
  return (
    <>
      {showCriticalAlert ? (
        <CriticalAlert />
      ) : (
        <InformativeAlert isActiveLoading={isActiveLoading} />
      )}
    </>
  );
};
